import { actionChannel, put, putResolve, select, take } from 'redux-saga/effects';

import type { SagaIterator } from '@redux-saga/types';

import { checkAvailability, cleanup } from '../../actions';
import { DELETE_FROM_BET_SLIP, DeleteFromBetSlip } from '../../actions/entries';
import { refreshMatchPrices } from '../../actions/stakeTypes/express';
import {
  FAILURE_SUBMISSION_END, FailureSubmissionEnd,
  processStakesComplete,
} from '../../actions/submission';
import { selectBets } from '../../selectors/entries';
import { selectExpressMatchPrices } from '../../selectors/stakeTypes/express';
import { AvailabilityStakesDAO } from '../../types/backend/availableStakes';
import { EntriesBets } from '../../types/entries';
import { ExpressMatchPrices } from '../../types/stakeTypes/express';
import { getAvailabilityPayload } from '../checkAvailability';

// ---

function* watchSubmissionEnd(entriesSize: number): SagaIterator {
  let entriesWithDecision = 0;
  let hasStakeWithError = false;
  let hasPriceChangeError = false;

  const channel = yield actionChannel([DELETE_FROM_BET_SLIP, FAILURE_SUBMISSION_END]);

  while (true) {
    const action: DeleteFromBetSlip | FailureSubmissionEnd = yield take(channel);

    switch (action.type) {
      case DELETE_FROM_BET_SLIP: {
        entriesWithDecision += action.payload.entries.length;
        break;
      }

      case FAILURE_SUBMISSION_END: {
        hasStakeWithError = true;
        hasPriceChangeError = action.payload.hasPriceChangeError;
        entriesWithDecision += action.payload.numberOfBets;
        break;
      }
    }

    const isLastEntry = entriesWithDecision === entriesSize;

    if (isLastEntry) {
      if (!hasStakeWithError) {
        yield put(cleanup());
      }

      let body: AvailabilityStakesDAO | null = null;

      if (hasPriceChangeError) {
        const bets: EntriesBets = yield select(selectBets);
        let expressPrices: ExpressMatchPrices = yield select(selectExpressMatchPrices);

        const payload = getAvailabilityPayload(bets);

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        body = (yield putResolve(checkAvailability(payload))).payload.data;

        const matchPrices = body?.express?.matchPrices;

        if (matchPrices) {
          const pricesKeys = Object.keys(matchPrices);

          pricesKeys.forEach((key) => {
            const entryPrice = expressPrices.get(parseInt(key))?.entryPrice;
            if (typeof entryPrice !== 'number') {
              console.error('BetSlip > saga > submission > watchSubmissionEnd > watchSubmissionEnd: `entryPrice` not found');
              return;
            }
            expressPrices = expressPrices.set(parseInt(key), {
              entryPrice,
              entityPrice: matchPrices[key],
            });
          });

          yield put(refreshMatchPrices(expressPrices));
        }
      }

      yield put(processStakesComplete(body));
      return;
    }
  }
}

export default watchSubmissionEnd;
